import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { recoverPwFields } from '../../../../formFields';
import { Button, Modal } from '../../../../modules/modules';
import Form from '../../../FormGenerator/Form';
import CountryService from '../../../../services/CountryService';

interface IRecoverPwProps extends RouteComponentProps<{ language: string; token: string }> {
  type?: string;
  onClose?: (e: any) => void;
  resetPassword?: MutationFunc;
}

interface IRecoverPwState {
  formFields: any[];
  formValues: any;
  modals: any;
}

class RecoverPw extends React.Component<IRecoverPwProps> {

  public state: IRecoverPwState;

  constructor(props: IRecoverPwProps) {
    super(props);

    this.state = {
      formFields: recoverPwFields,
      formValues: {},
      modals: {
        message: false
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.setFormState = this.setFormState.bind(this);
  }

  public handleChange(value: any, field: string) {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState(fields: any) {
    this.setState({ fields });
  }

  public async handleSend(form: any) {
    const validation = await form.validate((fields: any) => {
      this.setFormState(fields);
    });

    this.setState({ errorMessage: '' });

    if (validation) {
      this.recoverPw();
    }
  }

  public toggleModal(modal: string, open?: boolean) {
    if (open === undefined) {
      open = !this.state.modals[modal];
    }

    this.setState({ modals: { ...this.state.modals, [modal]: open } });
  }

  public render() {
    const { type } = this.props;
    const { countryCode } = CountryService.GetInstance();

    return (
      <React.Fragment>
        <div className={'recoverPw'}>
          <div>
            <div className="form form--recoverPw">
              <Form fields={this.state.formFields} values={this.state.formValues} handleChange={this.handleChange}>
                {(form: any) => {
                  return (
                    <div>
                      <Button
                        onClick={() => {
                          this.handleSend(form);
                        }}
                      >
                        Send
                      </Button>
                    </div>
                  );
                }}
              </Form>
            </div>
          </div>
          <div className="recoverPw__link">
            <Link to={`/${countryCode}/login`} className="link">
              Back to login
            </Link>
          </div>
        </div>

        <Modal type="message" open={this.state.modals.message} onClose={() => this.toggleModal('message', false)}>
          <div className="modal__title">Password has been changed</div>
          <Link to={`/${countryCode}/login`} className="link">
            Sign in
          </Link>
        </Modal>
      </React.Fragment>
    );
  }

  private async recoverPw() {
    if (this.props.resetPassword == undefined) {
      return;
    }

    const values = this.state.formValues;

    const variables = {
      token: this.props.match.params.token,
      newPassword: values.Password
    };

    const result = await this.props.resetPassword({
      variables
    });

    if ((result.data as any).resetPassword) {
      this.setState({ modals: { ...this.state.modals, ['message']: true } });
    }
  }
}

export default withRouter(RecoverPw);



// WEBPACK FOOTER //
// ./src/components/Query/User/RecoverPw/RecoverPw.tsx